export const reverseChargeCountryCodes = new Set([
  // Switzerland
  "CH",
  // United States
  "US",
  // Australia
  "AU",
  // Canada
  "CA",
  // Singapore
  "SG",
]);
